export enum TransactionType {
  Sale = 'SALE',
  Return = 'RETURN',
  Recurring = 'RECURRING',
  ConversionOnly = 'CONVERSIONONLY'
}

export const PRETTY_TRANSACTION_TYPE = {
  [TransactionType.Sale]: 'Sale',
  [TransactionType.Return]: 'Return',
  [TransactionType.Recurring]: 'Recurring',
  [TransactionType.ConversionOnly]: 'E-Check'
}
